(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["picsme-a4-portrait"] && !Shopify.designMode) return;
  try {
    (() => {
    function connectProductReviews() {
      document.querySelectorAll('.pm-a4-product-rating').forEach((link) => {
        if (link.dataset.reviewScrollReady === 'true') return;
        link.dataset.reviewScrollReady = 'true';
        link.addEventListener('click', (event) => {
          const reviews = document.getElementById('judgeme_product_reviews');
          if (!reviews) return;
          event.preventDefault();
          event.stopPropagation();
          reviews.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          reviews.setAttribute('tabindex', '-1');
          reviews.focus({ preventScroll: true });
        });
      });
    }
    connectProductReviews();
    document.addEventListener('shopify:section:load', connectProductReviews);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["picsme-cookie-preferences"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-picsme-cookie-preferences]');
    if (!button) return;
    const status = document.getElementById(button.getAttribute('aria-describedby'));
    if (status) status.hidden = true;
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
      if (status) status.hidden = false;
      return;
    }
    button.disabled = true;
    try {
      Promise.resolve(window.privacyBanner.showPreferences())
        .catch(function () { if (status) status.hidden = false; })
        .finally(function () { button.disabled = false; });
    } catch (error) {
      button.disabled = false;
      if (status) status.hidden = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["picsme-photobook"] && !Shopify.designMode) return;
  try {
    (() => {
    function connectProductReviews() {
      document.querySelectorAll('.pm-pb-product-rating').forEach((link) => {
        if (link.dataset.reviewScrollReady === 'true') return;
        link.dataset.reviewScrollReady = 'true';
        link.addEventListener('click', (event) => {
          const reviews = document.getElementById('judgeme_product_reviews');
          if (!reviews) return;
          event.preventDefault();
          event.stopPropagation();
          reviews.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          reviews.setAttribute('tabindex', '-1');
          reviews.focus({ preventScroll: true });
        });
      });
    }
    connectProductReviews();
    document.addEventListener('shopify:section:load', connectProductReviews);
  })();
  } catch(e) { console.error(e); }
})();

})();
